/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UnpublishedInputs */

const cs_unpublished = /** @type {(inputs: UnpublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepublikováno`)
};

const en_unpublished = /** @type {(inputs: UnpublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpublished`)
};

/**
* | output |
* | --- |
* | "Unpublished" |
*
* @param {UnpublishedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const unpublished = /** @type {((inputs?: UnpublishedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UnpublishedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unpublished(inputs)
	return cs_unpublished(inputs)
});